import React, { useEffect, useState } from "react";
import "./Lang.css";
import en from "../../../assets/images/Navbar/en.png";
import spa from "../../../assets/images/Navbar/spa.png";

const Language = () => {
  const [selectedOption, setSelectedOption] = useState({ value: "en", label: "English", imageSrc: en });
  const [openvalue,setopenvalue] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("language") === "en") {
      setSelectedOption({ value: "en", label: "English", imageSrc: en });
    } else if (localStorage.getItem("language") === "spa") {
      setSelectedOption({ value: "spa", label: "Spanish", imageSrc: spa });
    }

    if(window.innerWidth<=991){
      setopenvalue('none')
    }
    else{
      setopenvalue(null)
    }
  },[]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    localStorage.setItem("language", option.value);
    window.location.reload();
  };

  const openfn = ()=>{
    if(window.innerWidth<=991){
      if(openvalue=="none"){
        setopenvalue('block')
       }
       else{
        setopenvalue('none')
       }
    }
  
  }

  const options = [
    { value: "en", label: "English", imageSrc: en },
    { value: "spa", label: "Spanish", imageSrc: spa },
  ];

  return (
    <div className="custom-dropdown" onClick={openfn}>
      <div className="selected-option">
        {selectedOption && (
          <>
            <img
              src={selectedOption.imageSrc}
              alt={selectedOption.label}
              height={`20px`}
            />
            <span>{selectedOption.label}</span>
          </>
        )}
      </div>

      <ul className="options-list" style={{display:openvalue}}>
        {options.map((option) => (
          <li key={option.value} onClick={() => handleOptionClick(option)}>
            <img src={option.imageSrc} alt={option.label} height={`20px`} style={{padding:"0px 10px"}}/>
            {option.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Language;
